import type { ReactNode } from "react";

/** Width of a US Letter page in CSS pixels (8.5in at 96dpi). */
export const PAGE_WIDTH_PX = 816;
/** Height of a US Letter page in CSS pixels (11in at 96dpi). */
export const PAGE_HEIGHT_PX = 1056;
/** Horizontal padding inside the page (~0.5in). */
export const PAGE_PADDING_X = 48;
/** Vertical padding inside the page (~0.5in). */
export const PAGE_PADDING_Y = 48;
/** Usable content width inside page margins. */
export const PAGE_CONTENT_WIDTH = PAGE_WIDTH_PX - PAGE_PADDING_X * 2;
/** Usable content height inside page margins. */
export const PAGE_CONTENT_HEIGHT = PAGE_HEIGHT_PX - PAGE_PADDING_Y * 2;

interface PdfPageProps {
  children: ReactNode;
  paddingX?: number;
  paddingY?: number;
}

/**
 * Renders a fixed-size container representing a US Letter page (8.5" x 11").
 * @param children - Page content to render inside the page
 */
export function PdfPage({
  children,
  paddingX = PAGE_PADDING_X,
  paddingY = PAGE_PADDING_Y,
}: PdfPageProps) {
  return (
    <div
      className="pdf-page bg-white shadow-lg relative mx-auto overflow-hidden"
      style={{
        width: PAGE_WIDTH_PX,
        height: PAGE_HEIGHT_PX,
        padding: `${paddingY}px ${paddingX}px`,
      }}
    >
      {children}
    </div>
  );
}
